import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ToastContainer } from "react-toastify";

import { CustomRouter } from './router';

import './index.css';
import "react-toastify/dist/ReactToastify.min.css";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CssBaseline />
    <BrowserRouter>
      <CustomRouter />
      <ToastContainer limit={4} />
    </BrowserRouter>
  </React.StrictMode>
);
